import { connect } from "react-redux";

import ConversionList from "../Components/Conversions/ConversionList";
import { removeAllConversion, downLoadMDL } from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    conversions: state.conversions,
    converters: state.converters,
  };
};

const mapDispatchToProps = {
  removeAllConversion,
  downLoadMDL,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConversionList);
